import { useEffect, useState } from "react";
import { EVENT_CONFIG } from "@/config/eventConfig";

const Countdown = () => {
  const target = new Date(EVENT_CONFIG.event.dateISO).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = target - now;

  if (diff <= 0) {
    return (
      <section id="countdown" data-testid="countdown-section" className="bg-coal border-y border-champagne/15 py-14 text-center">
        <p className="font-script text-4xl sm:text-5xl gold-shimmer px-4">Tonight we build crowns.</p>
      </section>
    );
  }

  const units = [
    { label: "Days", value: Math.floor(diff / 86400000) },
    { label: "Hours", value: Math.floor((diff / 3600000) % 24) },
    { label: "Minutes", value: Math.floor((diff / 60000) % 60) },
    { label: "Seconds", value: Math.floor((diff / 1000) % 60) },
  ];

  return (
    <section id="countdown" data-testid="countdown-section" className="relative bg-coal border-y border-champagne/15 py-12 sm:py-16 grain">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.4em] text-gold mb-8">
          Countdown to the crown · November 7, 2026
        </p>
        <div className="grid grid-cols-4 gap-3 sm:gap-6">
          {units.map((u) => (
            <div
              key={u.label}
              data-testid={`hero-countdown-${u.label.toLowerCase()}`}
              className="gold-stroke rounded-2xl bg-ink/60 py-5 sm:py-8 px-2"
            >
              <div className="font-serif text-3xl sm:text-5xl lg:text-6xl gold-text tabular-nums">
                {String(u.value).padStart(2, "0")}
              </div>
              <div className="mt-2 text-[9px] sm:text-xs uppercase tracking-[0.3em] text-cream/70">
                {u.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Countdown;
